<template>
    <div class="popup">
        <div class="popup-content about">
            <div class="close-button" @click.prevent="closePopup">
                <font-awesome-icon class="font-awesome-icon" :icon="['far', 'times-circle']" size="lg"/>
            </div>
            <h3 class="title">About</h3>
            <p>
                <span>2020 Organiq</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        closePopup: function() {
            this.$emit('close');
        }
    }
}
</script>